import { Tab as FASTTab } from '@microsoft/fast-components';
import { foundationTabStyles as styles } from './tab.styles';
import { foundationTabTemplate as template } from './tab.template';
/**
 * @tagname %%prefix%%-tab
 */
export class Tab extends FASTTab {
}
// explicitly declaring for extensibility
export const foundationTabShadowOptions = undefined;
export const defaultTabConfig = {};
/**
 * The Foundation Tab
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-tab\>
 */
export const foundationTab = Tab.compose(Object.assign({ baseName: 'tab', template,
    styles, shadowOptions: foundationTabShadowOptions }, defaultTabConfig));
